import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export const cx = (...inputs: ClassValue[]) => {
  return clsx(inputs)
}
export const cxm = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs))
}
